/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */

import React from "react";
import { Component } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import OrderDetailsItem from "./OrderDetailsItem";
import * as userSelectors from "../selectors/user";

const StyledContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  background: white;
`;

const StyledGroupHeaderContainer = styled.div`
  display: flex;
  align-self: stretch;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 0 15px;
  line-height: 35px;
`;

const StyledGroupHeaderTitle = styled.span`
  margin-left: 12px;
  font-size: 0.9em;
  color: gray;
`;

class OrderGroupItem extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { groupItem } = this.props;
    const groupItemName = userSelectors.getUserCartItemStallName(groupItem);
    const groupItemChildItems = userSelectors.getUserCartItemStallItems(
      groupItem
    );

    return (
      <StyledContainer>
        <StyledGroupHeaderContainer>
          <img
            src={require("../assets/icons/stall.png")}
            style={{ width: "15px" }}
          />
          <StyledGroupHeaderTitle>{groupItemName}</StyledGroupHeaderTitle>
        </StyledGroupHeaderContainer>
        {groupItemChildItems && groupItemChildItems.length > 0
          ? groupItemChildItems.map((orderItem, index) => {
              return <OrderDetailsItem key={index} item={orderItem} />;
            })
          : null}
      </StyledContainer>
    );
  }
}

OrderGroupItem.propTypes = {
  groupItem: PropTypes.object.isRequired
};

OrderGroupItem.defaultProps = {};

export default OrderGroupItem;



// WEBPACK FOOTER //
// ./src/components/OrderGroupItem.js